import { VariantProps } from 'class-variance-authority';
import { FC } from 'react';
import { cvaIcon, cvaRoot } from './TogglerBadgeStyles';
import IconHit from '/public/icons/hit.svg';
import IconNew from '/public/icons/new.svg';
import IconOpenPlusOpen from '/public/icons/oneplusone.svg';
import IconSale from '/public/icons/sale.svg';

interface Props extends VariantProps<typeof cvaRoot> {}

const TogglerBadge: FC<Props> = ({ type }) => {
  return (
    <div className={cvaRoot({ type })}>
      {type === 'new' ? <IconNew className={cvaIcon()} /> : null}
      {type === 'sale' ? <IconSale className={cvaIcon()} /> : null}
      {type === 'hit' ? <IconHit className={cvaIcon()} /> : null}
      {type === '1+1' ? <IconOpenPlusOpen className={cvaIcon()} /> : null}
      {type}
    </div>
  );
};

export default TogglerBadge;
